module.exports = __webpack_public_path__ + "img/FGr_Wasserschaden-Pumpen.7b384999.svg";